var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,null,{
      loading: _vm.loading,
      loadingConfig: _vm.loadingConfig,
      item: _vm.item,
      fields: _vm.fields,
      hiddenFields: _vm.hiddenFields,
      mainFields: _vm.mainFields,
      methods: {
        getEntity: _vm.getEntity,
        getConfig: _vm.getConfig,
        clearEntity: _vm.clearEntity,
      },
    })],2)}
var staticRenderFns = []

export { render, staticRenderFns }